import { render, staticRenderFns } from "./OfferDetails.vue?vue&type=template&id=31c9fddd&scoped=true"
import script from "./OfferDetails.vue?vue&type=script&lang=js"
export * from "./OfferDetails.vue?vue&type=script&lang=js"
import style0 from "./OfferDetails.vue?vue&type=style&index=0&id=31c9fddd&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "31c9fddd",
  null
  
)

export default component.exports